import { API_ROUTE_TRADE_IN_AGREEMENTS } from '@/resources/api-routes'
import { get } from '@/util/auth'

type AgreementsOriginal = {
  id: string
  modifiedOn: string
  modifiedBy: string
  createdOn: string
  createdBy: string
  agreementText: string
  acceptedOn: string
  acceptedBy: string
  commission: number
  expirationDate: string
  activeFrom: string
}

const IS_NEW_BACKEND_API = true

export const getTradeInCustomerAgreements = async (customerId: number) =>
  await get<AgreementsOriginal[]>(
    API_ROUTE_TRADE_IN_AGREEMENTS.replace(':customerId', String(customerId)),
    IS_NEW_BACKEND_API
  )
